import React from 'react';
import { Helmet } from 'react-helmet';  // Import Helmet for SEO
import { Briefcase, Code, Smartphone, TrendingUp } from "lucide-react";

const NextGenTestingServices = () => {
  return (
    <section className="tech-services-section">
      {/* SEO Meta Tags */}
      <Helmet>
        <title>Next Gen Testing Services | Pravisht Digital</title>
        <meta
          name="description"
          content="Pravisht's Next Gen Testing Services ensure quality, security, and agility with automation, real-time validation, and scalable QA solutions."
        />
        <meta
          name="keywords"
          content="Test Automation, DevOps, Functional Testing, Non-Functional Testing, QA, Pravisht Digital, Performance Testing, Security Testing"
        />
        <meta property="og:title" content="Next Gen Testing Services | Pravisht Digital" />
        <meta
          property="og:description"
          content="Future-ready testing framework for performance, security, and agility across platforms and domains."
        />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet>
      <div className="breadcrumb">
        <a href="/" className="mx-1">Home</a> &gt; <span className="mx-1">Next Gen Testing Services</span>
      </div>

      <div className="about-heading-section">
        <h1>Next Gen Testing Services</h1>
        <p>
          Quality is at the heart of digital success. At Pravisht, our Next Gen Testing Services offer a future-ready framework that ensures performance, security, and agility across platforms and domains. From automated pipelines to real-time validation, we deliver resilient and scalable QA solutions.
        </p>
      </div>

      <div className="about-image-fullscreen">
        <img src="/testing_pravisht.jpg" alt="Pravisht Digital" />
      </div>

      <div className="core-offerings">
        <div className="how-we-help__content">
          <p className="how-we-help__description services-desc">Our Services</p>
          <h1 className="how-we-help__title">Our Testing Capabilities</h1>
          <hr className="portfolio-horizontalline" />
        </div>

        <div className="offerings-grid">
          <div className="offering-card app-dev-card">
            <h4>1. Test Automation &amp; DevOps</h4>
            <p>Enable continuous testing and faster delivery with automation-first strategies:</p>
            <ul>
              <li>Functional, Performance, and Security Test Automation</li>
              <li>Build CI/CD Pipelines and DevOps Setup</li>
              <li>Scalable Test Frameworks &amp; Parallel Execution</li>
            </ul>
          </div>

          <div className="offering-card consulting-card">
            <h4>2. Test Governance</h4>
            <p>Achieve test maturity with structured governance:</p>
            <ul>
              <li>Test Planning, Execution, and Tracking (RTM)</li>
              <li>Test Case Design &amp; Scenario Management</li>
              <li>Metrics and Progress Reporting</li>
            </ul>
          </div>

          <div className="offering-card iot-blockchain-card">
            <h4>3. Functional Testing</h4>
            <p>Ensure functionality meets expectation across platforms:</p>
            <ul>
              <li>Functional, Compatibility, and System Integration Testing</li>
              <li>Domain-Specific and Risk-Based Testing</li>
              <li>End-to-End Regression Suites</li>
            </ul>
          </div>

          <div className="offering-card automation-card">
            <h4>4. Non-Functional Testing</h4>
            <p>Validate performance and experience under all conditions:</p>
            <ul>
              <li>Security, Accessibility, Load &amp; Stress Testing</li>
              <li>Benchmark-based Performance Evaluation</li>
              <li>Compliance-Driven Testing for Accessibility Standards</li>
            </ul>
          </div>

          <div className="offering-card mobile-apps-card">
            <h4>5. Other Test Offerings</h4>
            <p>Comprehensive and extended coverage for enterprise assurance:</p>
            <ul>
              <li>SOA/Web Services Testing</li>
              <li>Mobile &amp; Database Testing</li>
              <li>Device Compatibility and Cross-Browser Testing</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="engagement-layers-and-why-choose" style={{ backgroundColor: '#f1f4f3' }}>
          <h3 className="section-subtitle">Our Testing Approach</h3>
          <p>Our testing methodology is engineered around five key delivery pillars:</p>
        

        <div className="bottom-sections-grid">
          <div className="how-we-help__cards">
            {[
              { icon: <Briefcase size={40} />, title: "On-Demand Testing", desc: "Agile, short-cycle testing aligned to business releases" },
              { icon: <Code size={40} />, title: "Game Testing", desc: "Playability, UI/UX consistency, and performance across platforms" },
              { icon: <Smartphone size={40} />, title: "Domain Testing", desc: "Tailored QA for sectors like healthcare, BFSI, logistics, etc." },
            //   { icon: <TrendingUp size={40} />, title: "CI/CD Integration", desc: "Seamless QA within your delivery pipeline" },
              { icon: <Briefcase size={40} />, title: "Automation Assurance", desc: "Scale testing with minimal manual effort" }
            ].map((card, i) => (
              <div className="how-we-help__card" key={i} style={{ height: '190px', cursor: 'default' }}>
                <h3 className="card-title">{card.title}</h3>
                <p className="card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NextGenTestingServices;
